import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import toast, { Toaster } from "react-hot-toast";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Header } from "antd/lib/layout/layout";
import PreferencesNav from "./PreferencesNav";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import AddIcon from "@mui/icons-material/Add";
import { BASE_URL_INVENTORY } from "../../CONSTANTS";
import DownloadIcon from "@mui/icons-material/Download";
import ImportExportIcon from "@mui/icons-material/ImportExport";

import {
  getHSNList,
  addHSN,
  updateHSN,
  uploadHsnExcel,
  downloadHsnExcel,
  uploadCustomerExcel,
} from "../../services/index";
import { searchForMatch } from "../utils/textUtils";

const HsnList = () => {
  let navigate = useNavigate();
  const [error, setError] = useState({});
  const [file1, setFile1] = useState({
    fileBase64: "",
    fileName: "",
  });
  const [recId, setRecId] = useState("");
  const [hsn, setHsn] = useState("");
  const [note, setNote] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [filteredData2, setFilteredData2] = useState([]);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => {
    setShow2(false);
  };
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => {
    setShow1(false);
  };
  const handleShow1 = () => {
    setShow1(true);
  };

  const [show, setShow] = useState(false);
  const handleClose = () => {
    setHsn("");
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };

  const columns = [
    {
      name: "HSN/SAC",
      cell: (row) => row.hsnSac,
    },
    {
      name: "NOTE",
      cell: (row) => row.description,
    },
  ];

  const handleSave = () => {
    if (hsn === "") {
      toast("Please fill hsnSac");
      return;
    }

    const data = {
      description: note,
      hsnSac: hsn,
    };

    if (recId) {
      updateHSN(recId, data).then((res) => {
        if (res.errorCode === 0) {
          toast(res.message);
          getHSNrecords();
          handleClose();
        } else {
          toast(res.message);
          return;
        }
      });
    } else {
      addHSN(data).then((res) => {
        if (res.errorCode === 0) {
          toast(res.message);
          getHSNrecords();
          handleClose();
        } else {
          toast(res.message);
          return;
        }
      });
    }
  };

  useEffect(() => {
    getHSNrecords();
  }, []);

  const getHSNrecords = () => {
    getHSNList().then((res) => {
      if (res.errorCode === 0) {
        var temp = res.responsePacket.data;
        temp.reverse();
        setFilteredData(temp);
        setFilteredData2(temp);
      } else {
        toast(res.data.message);
        return;
      }
    });
  };

  const handleFileRead = async (event) => {
    const file = event.target.files[0];
    const base64 = await convertBase64(file);
    const base = base64.split(",")[1];
    setFile1({
      fileBase64: base,
      fileName: file.name,
    });
  };
  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleUpload = () => {
    uploadHsnExcel(file1).then((res) => {
      if (res.errorCode === 0) {
        getHSNrecords();
        toast(res.message);
      } else {
        setError(res);
        setShow2(true);
      }
    });
    setTimeout(handleClose(), 6000);
  };

  const handleSearch = (key) => {
    const result = filteredData2.filter((a) => {
      return (
        searchForMatch(a.hsnSac?.toString(), key) ||
        searchForMatch(a.description, key)
      );
    });

    setFilteredData(result);
  };

  const handleClicked = (row) => {
    setRecId(row.recordId);
    setHsn(row.hsnSac);
    setNote(row.description);
    setShow(true);
  };

  return (
    <>
      <Modal show={show2} onHide={handleClose2}>
        <Modal.Body>
          <div>{error.message}</div>
          <br />
          {error.listOfErrors &&
            error.listOfErrors?.map((item) => {
              return <div>{item}</div>;
            })}
        </Modal.Body>
      </Modal>

      <Modal show={show1} onHide={handleClose1} size="sm">
        <Modal.Body>
          <input
            autoComplete="off"
            className="ember-text-field ember-view form-control "
            id="originalFileName"
            type="file"
            inputProps={{
              accept: "image/*, .xlsx, .xls, .csv, .pdf, .pptx, .pptm, .ppt",
            }}
            required
            label="Document"
            name="originalFileName"
            onChange={(e) => handleFileRead(e)}
            size="small"
            variant="standard"
          />
        </Modal.Body>

        <Modal.Footer>
          <a
            href={`${BASE_URL_INVENTORY}` + `hsn/downloadHsnExcel`}
            target="_blank"
            download
          >
            <Button variant="primary">
              <DownloadIcon /> Hsn List
            </Button>
          </a>

          <Button variant="primary" onClick={handleUpload}>
            Upload
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show} onHide={handleClose} size="sm">
        <Modal.Body>
          <Header>HSN Info</Header>
          <hr />

          <table style={{ width: "100%" }}>
            <tr>
              <td>HSN:</td>
              <td>
                {" "}
                <input
                  style={{ width: "100%" }}
                  autoComplete="off"
                  className="ember-text-field ember-view form-control"
                  onChange={(e) => {
                    setHsn(e.target.value);
                  }}
                  value={hsn}
                />
              </td>
            </tr>
            <tr>
              <td>Note:</td>
              <td>
                {" "}
                <input
                  autoComplete="off"
                  className="ember-text-field ember-view form-control"
                  onChange={(e) => {
                    setNote(e.target.value);
                  }}
                  value={note}
                />
              </td>
            </tr>
          </table>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <div className="column list-column d-print-none column-small">
        <PreferencesNav />
      </div> */}
      <div className="column content-column">
        <div className="header clearfix" style={{ borderBottom: "none" }}>
          <span className="float-left" style={{ fontSize: "35px" }}>
            HSN List
          </span>
        </div>

        <div style={{ height: 500, width: "100%" }}>
          <DataTable
            columns={columns}
            data={filteredData}
            fixedHeader
            pagination
            subHeader
            highlightOnHover={true}
            onRowClicked={(data) => handleClicked(data)}
            subHeaderComponent={
              <div className="d-flex align-items-center">
                <div className="input-group mr-2 paginationSearchInput">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <SearchRoundedIcon />
                    </span>
                  </div>
                  <input
                    autoComplete="off"
                    className="form-control"
                    type="text"
                    placeholder={"Search here"}
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                </div>
                <button
                  id="ember5839"
                  className="tooltip-container ember-view btn btn-primary d-flex align-items-center"
                  type="button"
                  onClick={handleShow}
                >
                  <AddIcon />
                  New
                </button>
                <button
                  id="ember5839"
                  className="tooltip-container ember-view btn btn-primary d-flex align-items-center"
                  type="button"
                  onClick={() => setShow1(true)}
                >
                  <ImportExportIcon />
                  Export
                </button>
              </div>
            }
          />
        </div>
      </div>
      <Toaster />
    </>
  );
};

export default HsnList;
